import * as React from "react"

import { createIcon } from "@chakra-ui/react"

export const ArrowLeftIcon = createIcon({
  displayName: "ArrowLeftIcon",
  viewBox: "0 0 20 8",
  path: (
    <path
      d="M3.5 0.500001L-3.0598e-07 4L3.5 7.5L4.207 6.793L1.914 4.5L20 4.5L20 3.5L1.914 3.5L4.207 1.207L3.5 0.500001Z"
      fill="#2E3A59"
    />
  ),
})
